import React, { memo, useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import { rem, Spacer } from 'design-system';
import useColors from 'hooks/useColors';
import YLabels from './YLabels';
import EachTimeFrame from './EachTimeFrame';
import { getBarHeight, getMaxMin, getYLabels } from './utils';
const TimeFrame = ({ data, selectedIndex, setSelectedIndex, firstBarColor: firstBarColorProps, thirdBarColor: thirdBarColorProps, secondBarColor: secondBarColorProps, }) => {
    const colors = useColors();
    const handleSetSelectedIndex = useCallback((index) => () => {
        setSelectedIndex(index);
    }, [setSelectedIndex]);
    const totalFrames = data.length;
    if (!totalFrames)
        return null;
    const { maxY, minY } = getMaxMin(data);
    const firstBarColor = firstBarColorProps ?? colors.elements.brand;
    const secondBarColor = secondBarColorProps ?? colors.elements.income;
    const thirdBarColor = thirdBarColorProps ?? colors.gradients.darkPink.colors[0];
    const { maxHeightPositive, maxHeightNegative, yLabels } = getYLabels(maxY, minY);
    return (<View style={styles.container}>
      <View style={styles.framesContainer}>
        {data.map((eachData, index) => (<EachTimeFrame index={index} key={String(index)} label={eachData.label} selectedIndex={selectedIndex} firstBarColor={firstBarColor} thirdBarColor={thirdBarColor} secondBarColor={secondBarColor} maxHeightPositive={maxHeightPositive} maxHeightNegative={maxHeightNegative} setSelectedIndex={handleSetSelectedIndex(index)} thirdBarY={getBarHeight(eachData.thirdBarY, maxY, minY, maxHeightPositive, maxHeightNegative)} firstBarY={getBarHeight(eachData.firstBarY, maxY, minY, maxHeightPositive, maxHeightNegative)} secondBarY={getBarHeight(eachData.secondBarY, maxY, minY, maxHeightPositive, maxHeightNegative)}/>))}
      </View>
      <Spacer w={8}/>
      <YLabels yLabels={yLabels}/>
    </View>);
};
export default memo(TimeFrame);
const styles = StyleSheet.create({
    container: {
        paddingTop: rem(24),
        flexDirection: 'row',
    },
    framesContainer: {
        flex: 1,
        flexDirection: 'row-reverse',
    },
});
